import React from 'react';
import $ from 'jquery';
import { unmountRootAtNode } from '../../utilities/reactRoot';
import { getApiTemplateUrl, getApiTemplatesUrl } from '../../utilities/urlHelper';

class CreateFromTemplateModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            templates: [],
            loading: true,
        };
    }

    componentDidMount() {
        if (this.state.loading && !window.hasOwnProperty('tettraTemplates')) {
            const loading = false;
            const url = getApiTemplatesUrl();
            $.get(url)
                .then(({ pages: templates }) => {
                    this.setState({ templates, loading });
                    window.tettraTemplates = templates;
                });
        } else {
            this.setState({
                loading: false,
                templates: window.tettraTemplates,
            });
        }
    }

    closeModal = () => {
        if (this.props.closeModal) {
            this.props.closeModal();
        }
    };

    onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            this.closeModal();
        }
    };

    selectTemplate = (templateId) => {
        if (this.props.selectTemplate) {
            return this.props.selectTemplate(templateId);
        }
        return this.createPage(templateId);
    };

    createPage = (templateId) => {
        this.setState({ loading: true });
        const url = getApiTemplateUrl(templateId);
        $.get(url)
            .then(({ page: template }) => {
                const { editor_state: editorState, title } = template;
                $('#post-editor-title').text(title);
                unmountRootAtNode($('#post-editor-content')[0]);
                window.tettraEditor.renderWithRawState(JSON.parse(editorState));
                this.closeModal();
            });
    };

    render() {
        const { loading, templates } = this.state;
        const templateList = templates.length && templates.map((template) => (
            <li className="mxn2 flex p2 template-row" key={template.id}>
                <img className="flex-none" height="28" src="/img/icons/file-icon-template.png" />
                <h4 className="flex-auto mb0 mt0 ml2 template-row-title">
                    <a href="#" onMouseDown={() => this.selectTemplate(template.id)}>
                        {template.title}
                    </a>
                </h4>
                <div className="flex-none">
                    <button onMouseDown={() => this.selectTemplate(template.id)} className="btn-tertiary left">Select</button>
                </div>
            </li>
        ));
        const noTemplates = (
            <div>
You don't have any templates.
                <a href={`/teams/${window.teamDomain}/drafts/create?template=true`}>Create one.</a>
            </div>
        );

        return (
            <div className="react-modal open fullscreen" onMouseDown={this.onClickModal}>
                <div className="modal-content create-from-template">
                    <h2>Templates</h2>
                    {loading && <span>Loading...</span>}
                    {!loading && (
                        <div>
                            <div className="modal-content__body">
                                <ul className="list-reset m0">
                                    {templateList || noTemplates}
                                </ul>
                            </div>
                            <div className="mt2 right-align">
                                <span onClick={this.closeModal} className="react-modal-close btn-secondary mr2">Close</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default CreateFromTemplateModal;
